export class DuvidasSugestoesModel {
    email: string
    telefone: string
    mensagem: string
    assuntos: Array<string>
    assunto: string
    anexo: string
}


// WEBPACK FOOTER //
// ./src/pages/duvidas-sugestoes/duvidas-sugestoes.modelview.ts